/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlViolationTrackerViolation } from './ControlViolationTrackerViolation';
import {
    ControlViolationTrackerViolationFromJSON,
    ControlViolationTrackerViolationFromJSONTyped,
    ControlViolationTrackerViolationToJSON,
} from './ControlViolationTrackerViolation';

/**
 * 
 * @export
 * @interface ControlPaginatedViolationTrackerResponse
 */
export interface ControlPaginatedViolationTrackerResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedViolationTrackerResponse
     */
    total: number;
    /**
     * 
     * @type {Array<ControlViolationTrackerViolation>}
     * @memberof ControlPaginatedViolationTrackerResponse
     */
    results: Array<ControlViolationTrackerViolation>;
    /**
     * 
     * @type {string}
     * @memberof ControlPaginatedViolationTrackerResponse
     */
    schema_version: string;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedViolationTrackerResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedViolationTrackerResponse
     */
    page_size: number;
}

/**
 * Check if a given object implements the ControlPaginatedViolationTrackerResponse interface.
 */
export function instanceOfControlPaginatedViolationTrackerResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "results" in value;
    isInstance = isInstance && "schema_version" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "page_size" in value;

    return isInstance;
}

export function ControlPaginatedViolationTrackerResponseFromJSON(json: any): ControlPaginatedViolationTrackerResponse {
    return ControlPaginatedViolationTrackerResponseFromJSONTyped(json, false);
}

export function ControlPaginatedViolationTrackerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaginatedViolationTrackerResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'results': ((json['results'] as Array<any>).map(ControlViolationTrackerViolationFromJSON)),
        'schema_version': json['schema_version'],
        'page': json['page'],
        'page_size': json['page_size'],
    };
}

export function ControlPaginatedViolationTrackerResponseToJSON(value?: ControlPaginatedViolationTrackerResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ControlViolationTrackerViolationToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

